import React from "react";
import {Card, classNames, SimpleCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {animatePulse} from "@/utils/LoadingUtils";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import SentBy from "../internalNote/SentBy";
import {FormattedMessage, useIntl} from "react-intl";


type Props = {
    jobApplication: JobApplicationDetails | undefined,
};

const JobApplicationMotivation = ({jobApplication}: Props) => {
    const intl = useIntl();

    return (
        <Card
            containerClassname={"w-full mt-8 xl:mt-[63px] text-sm"}
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"motivation"}/>}/>
                </CardHeader>
            }
        >
            <div
                className={"w-full flex flex-col"}
                role={"region"}
            >
                <SentBy jobApplication={jobApplication}/>

                <div
                    role={"region"}
                    aria-label={intl.formatMessage({id: "motivation"})}
                    className={classNames(
                        "w-full border p-6 rounded border-gray-200 dark:border-slate-700 bg-gray-300/20 dark:bg-slate-600/20 mt-6 mb-2 min-h-[200px] whitespace-break-spaces",
                        jobApplication === undefined ? "bg-gray-200 dark:bg-slate-700" : "",
                        animatePulse(jobApplication === undefined),
                    )}
                >
                    {jobApplication && jobApplication.motivation}
                </div>
            </div>
        </Card>
    );
};

export default JobApplicationMotivation;